// extracted by mini-css-extract-plugin
export var isPrintedCell = "_x3-1";
export var printerIcon = "_x3-0";